import 'lodash'
import 'magnific-popup'
import 'lightbox2/dist/js/lightbox'

theme.Product = (function () {
  function Product(container) {
    this.container = container
    var $container = (this.$container = $(container)),
      sectionId = $container.attr('data-section-id')

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    }

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      saveAmount: '#SaveAmount-' + sectionId,
      discountBadge: '.discount-badge',
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '.FeaturedImage-' + sectionId,
      productImageWrap: '.FeaturedImageZoom-' + sectionId + '.slick-active',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productMediaTypeModel: '[data-product-media-type-model]',
    }

    // Magnific Popup
    $('.mfp-link').magnificPopup({
      delegate: '.mfp',
      removalDelay: 300,
      callbacks: {
        beforeOpen: function () {
          $('.stickyHeader').addClass('popup')
          this.st.mainClass = this.st.el.attr('data-effect')
        },
        close: function () {
          $('.stickyHeader').removeClass('popup')
        },
      },
      midClick: true,
    })

    if ($('.product-single__media').length > 0) {
      $('.product-single__media').each(function () {
        const video = $(this).find('video')
        const btn = $(this).find('.play-pause')

        if (typeof video[0] === 'object') {
          btn[0].addEventListener('click', function () {
            if (video[0].paused == true) {
              video[0].play()
              btn[0].classList.toggle('pause')
            } else {
              video[0].pause()
              btn[0].classList.toggle('pause')
            }
          })
        }
      })
    }

    // Product tabs
    var tabs = (this.tabs = '#ProductSection-' + sectionId + ' .tablink')

    $(tabs).on('click', function (e) {
      e.preventDefault()
      $(this).parent().addClass('active')
      $(this).parent().siblings().removeClass('active')
      var tab = $(this).attr('href')
      $('.tab-content').not(tab).css('display', 'none')
      $(tab).fadeIn()
      if ($(window).width() < 767) {
        var tabposition = $(this).offset()
        $('html, body').animate({ scrollTop: tabposition.top }, 500)
      }
    })

    $('.product-tabs li:first-child').addClass('active')
    $('.tab-container h3:first-child').addClass('active')
    $('.tab-container h3:first-child + .tab-content').show()

    $('.reviewLink, .moredetail a').on('click', function (e) {
      e.preventDefault()
      var tab = $(this).attr('href')
      $('.product-tabs li').removeClass('active')
      $(".tablink[href='" + tab + "']")
        .parent()
        .addClass('active')
      $('.tab-content').not(tab).css('display', 'none')
      $(tab).fadeIn()
      var tabposition = $(tab).offset()
      if ($(window).width() < 767) {
        $('html, body').animate({ scrollTop: tabposition.top - 100 }, 700)
      } else {
        $('html, body').animate({ scrollTop: tabposition.top - 150 }, 700)
      }
    })

    // $('.stickyOptions .selectedOpt').on('click', function () {
    //   $('.stickyOptions ul').slideToggle('fast')
    // })
    $('.stickyOptions .vrOpt').on('click', function (e) {
      // $(".stickyOptions ul li").each(function (index, elem) {
      //   console.log($(this), elem, index);
      //   $(this).removeClass("active");
      // });
      $('.stickyOptions ul li').removeClass('active')
      var value = $(this).attr('data-val'),
        number = $(this).attr('data-no'),
        text = $(this).text()
      $(this).addClass('active')

      $('.selectedOpt').text(text)

      $('.stickyCart .selectbox').val(value).trigger('change')
      this.productvariants = JSON.parse(
        document.getElementById('ProductJson-' + sectionId).innerHTML
      )
    })

    // change variant on image sections
    if (typeof variantImages !== 'undefined') {
      $(this.selectors.productThumbImages).bind('click', function () {
        var arrImage = $(this).attr('href').split('?')[0].split('.')
        var strExtention = arrImage.pop()
        var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '')
        var strNewImage =
          arrImage.join('.') + '.' + strRemaining + '.' + strExtention
        if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
            optionValue = variantImages[strNewImage]['option-' + i]
            if (
              optionValue !== null &&
              $('.single-option-selector:eq(' + i + ') option').filter(
                function () {
                  return $(this).text() === optionValue
                }
              ).length
            ) {
              $('.swatch-' + i)
                .find('.swatchInput[value="' + optionValue + '"]')
                .prop('checked', true)
              $('.single-option-selector:eq(' + i + ')')
                .val(optionValue)
                .trigger('change')
            }
          })
        }
      })
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    )

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass(
      'js-zoom-enabled'
    )
    this.settings.imageSize = theme.Images.imageSize(
      $(this.selectors.productFeaturedImage).attr('src')
    )

    // this._initBreakpoints();
    this._stringOverrides()
    this._initVariants()
    this._initImageSwitch()
    this._initThumbnailSlider()
    // this._setActiveThumbnail();
    this._initModelViewerLibraries()
    this._initShopifyXrLaunch()

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    )

    if (window.matchMedia('(min-width: 1025px)').matches) {
      $(".primgSlider .zoom-photo").on('click', function (evt) {
        evt.preventDefault()

        var aid = $(this).attr("href")

        if ($('#zoom-images').is(':empty')){
          var images3 = $.map($(".zoom-photo"), function(el) {
            return {src: $(el).data().fullimage, id: $(el).data().imageid, thumb: $(el).data().thumbimage};
          })
          $.each(images3, function(index,value) {
            $('<div class="product-single__photo" id="photo-' + value['id'] + '"><span class="imgWrapper"><img class="imgFl" src="' + value['src'] + '"></span></div>').appendTo("#zoom-images")
          })
          $.each(images3, function(index,value) {
            $('<a href="#photo-' + value['id'] + '" class="zoom-thumb__link zoom-photo"><img class="imgFl" src="' + value['thumb'] + '"></div>').appendTo("#zoom-thumbs")
          })
        }

        $(window).scrollTop(0)

        $("#ProductSection-" + sectionId).hide()
        $("#refresh-zoom-cont").show()

        setTimeout(function () {
          $('html, body').animate({scrollTop: $(aid).offset().top}, 700)
        }, 300)
      })

      $(".zoom-close").on('click', function () {
        $(window).scrollTop(0)
        $("#ProductSection-" + sectionId).show()
        $("#refresh-zoom-cont").hide()
      })

      $(document).on('click','#zoom-thumbs a',function(e) {
        var tid = $(this).attr("href");
        $('html, body').animate({scrollTop: $(tid).offset().top}, 700)
      })

      $(window).scroll(function() {
        scrollZoom()
      })

      function scrollZoom() {
        const scrollPos = $(document).scrollTop()
        $('#zoom-thumbs a').each(function () {
          const currLink = $(this)
          const refElement = $(currLink.attr('href'))
          if (
            refElement.position().top <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
          ) {
            $('#zoom-thumbs a').removeClass('active')
            $('#zoom-images .product-single__photo').removeClass('active')
            currLink.addClass('active')
            refElement.find('#zoom-images .product-single__photo').addClass('active')
          } else {
            currLink.removeClass('active')
            refElement.find('#zoom-images .product-single__photo').removeClass('active')
          }
        })
      }

      $(function(){
        var topPos = $('#zoom-thumbs').offset().top;
        var topClose = $('.zoom-close span').offset().top;
        $(window).scroll(function() {
          var top = $(document).scrollTop(),
          pip = $('.stop-fixed').offset().top,
          height = $('#zoom-thumbs').outerHeight(),
          heightClose = $('.zoom-close span').outerHeight();
          if (top > topPos && top < pip - height) {
            $('#zoom-thumbs').addClass('fixed').removeAttr("style")
          } else if (top > pip - height) {
            $('#zoom-thumbs').removeClass('fixed').css({'position':'absolute','bottom':'0'})
          } else {
            $('#zoom-thumbs').removeClass('fixed')
          }
          if (top > topPos && top < pip - heightClose) {
            $('.zoom-close span').addClass('fixed').removeAttr("style")
            $('.zoom-close').removeAttr("style")
          } else if (top > pip - heightClose) {
            $('.zoom-close span').removeClass('fixed').css({'position':'relative'})
            $('.zoom-close').css({'top':'auto','bottom':'10px'})
          } else {
            $('.zoom-close span').removeClass('fixed')
          }
        })
      })

    }

  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {}
      $.extend(theme.strings, theme.productStrings)
    },

    _initBreakpoints: function () {
      var self = this

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap))
          }
          self.settings.bpSmall = true
        },
        unmatch: function () {
          self.settings.bpSmall = false
        },
      })

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap))
          }
        },
      })
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      }

      this.variants = new slate.Variants(options)

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      )
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      )
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      )
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      )
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return
      }
      var self = this
      $(this.selectors.productThumbImages).on('click', function (evt) {
        evt.preventDefault()
        var $el = $(this),
          imageSrc = $el.attr('href'),
          zoomSrc = $el.data('zoom')
        // self._setActiveThumbnail(imageSrc);
        self._switchImage(imageSrc, zoomSrc)
      })
    },

    _switchImage: function (image, zoomImage) {
      if (
        $('.index-section--featured-product').length ||
        $('.custom__item-inner .ptContainer').length
      ) {
        var $image = $(
          this.selectors.productImageWrap + '[data-zoom="' + zoomImage + '"]'
        ).data('slide')
        $(this.selectors.productFeaturedImage).attr('src', image)

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          _destroyZoom($(this.selectors.productImageWrap))
        }

        if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
          $(this.selectors.productImageWrap).data('zoom', zoomImage)
          _enableZoom($(this.selectors.productImageWrap))
        }
      }
    },

    // _setActiveThumbnail: function (src) {
    //   var activeClass = "active-thumb";

    //   // If there is no element passed, find it by the current product image
    //   if (typeof src === "undefined") {
    //     src = $(this.selectors.productThumbImages + ".activeSlide").attr(
    //       "href"
    //     );
    //   }

    //   // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
    //   var $thumbnail = $(
    //     this.selectors.productThumbImages + '[href="' + src + '"]'
    //   );
    //   $(this.selectors.productThumbImages).removeClass(activeClass);
    //   $thumbnail.addClass(activeClass);
    //   var slideno = $thumbnail.parent().data("slide");
    //   if (
    //     theme.productStrings.prStyle == "style4" ||
    //     theme.productStrings.prStyle == "style5"
    //   ) {
    //     var imgposition = $(
    //       ".product-single__photo[data-slide='" + slideno + "']"
    //     ).offset();
    //     if ($(window).width() > 767) {
    //       $("html, body").animate({ scrollTop: imgposition.top - 70 }, 700);
    //     } else {
    //       $(".primgSlider").slick("slickGoTo", slideno);
    //     }
    //   } else {
    //     $(".primgSlider").slick("slickGoTo", slideno);
    //   }
    // },

    _initThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick()
      $('.primgSlider').slick()

      $('.primgSlider').slick('unslick')
      $(window).on('load resize', function () {
        if (window.matchMedia('(min-width: 1025px)').matches) {
          $('.primgSlider').slick('unslick')
        } else {
          $('.primgSlider').slick('refresh')
        }
      })

      $(window).on('load', function (e) {
        $('.product-single__thumbnails-item[data-slide="0"] .prvideo').trigger(
          'click'
        )
        var video = $('.primgSlider .videoSlide.slick-active video').get(0)
        if ($(video).length) {
          video.play()
        }
      })

      // var zoomItem = this.selectors.productImageWrap,
      //   enableZoom = !this.settings.bpSmall && this.settings.zoomEnabled;
      // if (enableZoom) {
      //   _destroyZoom(zoomItem);
      //   _enableZoom(zoomItem);
      // }
      $('.primgSlider').on(
        'afterChange',
        function (event, slick, currentSlide) {
          // if (enableZoom) {
          //   _destroyZoom(zoomItem);
          //   _enableZoom(zoomItem);
          // }

          if ($('.primgSlider .videoSlide video').length) {
            $('.primgSlider .videoSlide video').get(0).pause()
          }
          var video = $('.primgSlider .videoSlide.slick-active video').get(0)
          if ($(video).length) {
            video.play()
          }

          if ($('.slick-current model-viewer').length) {
            $(
              '.slick-current .shopify-model-viewer-ui__button--poster'
            ).trigger('click')
          }
        }
      )
    },

    _initModelViewerLibraries: function () {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.productMediaTypeModel
      )
      if (modelViewerElements.length < 1) return
      theme.ProductModel.init(modelViewerElements, this.settings.sectionId)
    },

    _initShopifyXrLaunch: function () {},

    _initShopifyXrLaunchHandler: function () {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          self.classes.hidden +
          ')'
      )
      currentMedia.dispatchEvent(
        new CustomEvent('xrLaunch', {
          bubbles: true,
          cancelable: true,
        })
      )
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true')

        if (variant.unit_price != undefined) {
          $('[data-unit-price]').html(
            theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
          )
          $('[data-unit-base]').html(
            variant.unit_price_measurement.reference_value +
              variant.unit_price_measurement.reference_unit
          )
          $('.price__unit').removeClass('hide')
        } else {
          $('.price__unit').addClass('hide')
        }

        if (variant.available) {
          var quantity = $('#pvr-' + variant.id).text(),
            maxquantity = $('#quantity_message').data('qty')

          $(this.selectors.addToCart).prop('disabled', false)

          if (quantity < 1 && variant.inventory_management == 'shopify') {
            $(this.selectors.addToCartText).text(theme.strings.preOrder)
          } else {
            $(this.selectors.addToCartText).text(theme.strings.addToCart)
          }

          if (quantity < 1 && variant.inventory_management == 'shopify') {
            $('.stockLbl')
              .removeClass('instock outstock')
              .addClass('preorder')
              .text($('.stockLbl').data('pre'))
          } else {
            $('.stockLbl')
              .removeClass('preorder outstock')
              .addClass('instock')
              .text($('.stockLbl').data('in'))
          }
          if (
            quantity < maxquantity &&
            quantity != 0 &&
            variant.inventory_management == 'shopify'
          ) {
            $('#quantity_message').show().find('.items').text(quantity)
          } else {
            $('#quantity_message').hide()
          }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true)
          $(this.selectors.addToCartText).text(theme.strings.soldOut)
          $('.stockLbl')
            .removeClass('preorder instock')
            .addClass('outstock')
            .text($('.stockLbl').data('out'))
          $('#quantity_message').hide()
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true)
        $(this.selectors.addToCartText).text(theme.strings.unavailable)
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false')
        $('.stockLbl')
          .removeClass('preorder instock')
          .addClass('outstock')
          .text($('.stockLbl').data('out'))
        $('#quantity_message').hide()
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant,
        sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        ),
        zoomSizedImgUrl
      // this._setActiveThumbnail(sizedImgUrl);
      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageZoomSize
        )
      }
      this._switchImage(sizedImgUrl, zoomSizedImgUrl)
    },

    _updatePrice: function (evt) {
      var variant = evt.variant

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      )

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide')
        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        )
        $(this.selectors.saleLabel).removeClass('hide')
        var price1 = variant.compare_at_price - variant.price,
          price2 = price1 * 100,
          salecount = price2 / variant.compare_at_price
        $(this.selectors.discountBadge)
          .find('.off')
          .find('span')
          .text(+salecount.toFixed())
        $(this.selectors.discountBadge).removeClass('hide')
        $(this.selectors.saveAmount).html(
          theme.Currency.formatMoney(price1, theme.moneyFormat)
        )
      } else {
        $(this.selectors.comparePrice).addClass('hide')
        $(this.selectors.saleLabel).addClass('hide')
        $(this.selectors.discountBadge).addClass('hide')
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        )
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant
      $(this.selectors.SKU).html(variant.sku)
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace)
    },
  })

  function _enableZoom($el) {
    $($el).each(function () {
      var zoomUrl = $(this).data('zoom')
      $(this).zoom({
        url: zoomUrl,
      })
    })
  }

  function _destroyZoom($el) {
    $($el).each(function () {
      $(this).trigger('zoom.destroy')
    })
  }
  return Product
})()
